import { render, staticRenderFns } from "./RegistroPis.vue?vue&type=template&id=178ab446&scoped=true&"
import script from "./RegistroPis.vue?vue&type=script&lang=js&"
export * from "./RegistroPis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178ab446",
  null
  
)

export default component.exports